// extracted by mini-css-extract-plugin
export default {"wrapper":"mobileInnerWrapper_wrapper__GI6z-","isCentered":"mobileInnerWrapper_isCentered__eLPa0"};